import { Seo } from "../../components/Seo";
import { RichText } from "../../components/RichText";
import { useTeam } from "../../api/hooks";
import { LoadingSection } from "../../components/Spinner";

export function Team() {
  const { data: team, isLoading } = useTeam();

  return (
    <>
      <Seo
        title="L'équipe"
        description="Découvrez l'équipe de coachs certifiés CrossFit d'Héraclès Brest et Landerneau."
        path="/equipe"
      />

      <section className="bg-paper py-10 text-ink-900">
        <div className="container">
          <span className="eyebrow">L'équipe</span>
          <h1 className="h-hero mt-2">Nos coachs</h1>
          <p className="mt-4 max-w-2xl text-ink-500">
            Tous nos coachs sont certifiés CrossFit (Level 1, Level 2, Gymnastic, Weightlifting, Kids)
            et formés à l'accompagnement individualisé.
          </p>
        </div>
      </section>

      <section className="section">
        {isLoading && <LoadingSection />}
        <div className="container grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {team?.map((coach) => (
            <article key={coach.id} className="card">
              <div className="aspect-square overflow-hidden rounded-md bg-ink-100">
                {coach.photoUrl && (
                  <img
                    src={coach.photoUrl}
                    alt={coach.name}
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                )}
              </div>
              <h2 className="mt-4 font-display text-xl font-bold uppercase">{coach.name}</h2>
              <p className="text-sm font-semibold text-brand-500">{coach.role}</p>
              <RichText
                value={coach.bio}
                className="prose-bio mt-2 text-sm text-ink-500"
              />
              {coach.certifications.length > 0 && (
                <ul className="mt-3 flex flex-wrap gap-1">
                  {coach.certifications.map((c) => (
                    <li
                      key={c}
                      className="rounded bg-ink-100 px-2 py-0.5 text-xs font-semibold text-ink-700"
                    >
                      {c}
                    </li>
                  ))}
                </ul>
              )}
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
